import script from "./NewsPageBodyNewsfeedItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageBodyNewsfeedItem.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageBodyNewsfeedItem.vue?vue&type=style&index=0&id=6f901bd6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f901bd6"]])

export default __exports__